module.exports = __webpack_public_path__ + "img/small-logo.0a905d4f.png";